export default __webpack_public_path__ + "static/media/git.a506684b.svg";